<script>
    import { createEventDispatcher } from "svelte";
    import DTInputCell from "../common/DTInputCell.svelte";
    import IconButton, { Icon } from "@smui/icon-button";
    import DataTable, { Head, Body, Row, Cell, Label } from "@smui/data-table";
    import Tooltip, { Wrapper, Content } from "@smui/tooltip";
    import { mdiContentSaveOutline, mdiContentSave, mdiCloseThick, mdiPencilBoxOutline } from "@mdi/js";
    import { _ } from "svelte-i18n";
    import { formatVolume, isNumber } from "../lib/Functions";
    import { onMount } from 'svelte';
    import { minLogistics, maxLogistics } from "../../../stores/AppConfig";

    export let value;
    export let rowStyle = "";
    export let type = "carton";
    export let logisticsCheckType = "ALL";
    export let purchaseLogistics;
    export let productLogistics;
    export let qsLogistics;
    export let lwLogistics;
   export let editDisabled = false;
 
    let oldValue = 0;
    let valueInvalid = false;
    let editing = false;


    const dispatch = createEventDispatcher();

    onMount(() => {
        oldValue = value;
        editing = false;
    })

    $: {
        if (type == "promo" && (!value || value == null || value == "" || (isNumber(String(value).replaceAll(',','.')) && Number(String(value).replaceAll(',','.')) === 0))) {
            valueInvalid = false;
        }  else if (value &&
                       isNumber(String(value).replaceAll(',','.')) && 
                       Number(String(value).replaceAll(',','.')).countDecimals() == 0 &&
                       (Number(String(value).replaceAll(',','.')) >= minLogistics && Number(String(value).replaceAll(',','.')) <= maxLogistics)) {
           valueInvalid = false;
        } else {
          valueInvalid = true;
        }
    }
    $: saveDisabled = (valueInvalid || Number(String(value).replaceAll(',','.')) == oldValue);

    function handleKeyEvent(event){
        if (event.key === 'Escape') {
            value = oldValue;
            editing = false;
            dispatch("finishEdit");
        }
    }

    function handleSaveButton() {
        if (valueInvalid || saveDisabled) {
            value = oldValue;
            editing = false;
            dispatch("finishEdit");
        } else {
            saveChange();
        }
    }

    function handleFocus (event) {
        //console.log("==================== handleFocus =====================", event.target);
        //event.target.select(); // Throws exception !!!
    }

    function saveChange() {
        console.log("==================== saveChange =====================",{value}, {oldValue} );
        if (!valueInvalid)  {
            let val = Number(String(value).replaceAll(',','.'));
            oldValue = val;
            value = String(val);
            editing = false;
            dispatch("valueChanged", { value: val });
            dispatch("finishEdit");
        }
    }

</script>

<Cell numeric class="{rowStyle} right-splitter-sub noborder {(!editing)? "  ":""}" style="max-width: 8em; ">
    {#if editing}
        <div class="{rowStyle} datatable-cell " style="justify-content: end; display: inline">
            <DTInputCell
                bind:value={value}
                editable={true}
                autofocus={false}
                class="small"
                extraClasses="inline-logistics-edit white-bg "
                withTrailingIcon={false}
                {valueInvalid}
                ignoreFocus={true}
                on:keyup={handleKeyEvent}
                on:focus={handleFocus}
            />
            <!--<IconButton size="button" class="tescoblue-text opacity-1" title="{valueInvalid? "cancel":$_('save_'+ (type=="promo"? "promo_":"")+'logistics_change')}" disabled={saveDisabled && !valueInvalid} on:click="{handleSaveButton}">-->
            <IconButton size="button" class="tescoblue-text opacity-1" title="{(valueInvalid || saveDisabled)? "cancel":$_('save_'+ (type=="carton"? "carton_":"pallet_")+'logistics_change')}" on:click="{handleSaveButton}">
                <Icon tag="svg" viewBox="0 0 24 24" class="{saveDisabled? (valueInvalid? "tescored-text":"tescored-text"):"green-text"}">
                    {#if saveDisabled}
                        {#if valueInvalid}
                            <path fill="currentColor" d={mdiCloseThick} />
                        {:else}
                            <path fill="currentColor" d={mdiCloseThick} />
                            <!--<path fill="currentColor" d={mdiContentSaveOutline} />-->
                        {/if}
                    {:else}
                            <path fill="currentColor" d={mdiContentSave} />
                    {/if}
                </Icon>
            </IconButton>
        </div>
    {:else}
    <!--    <Cell class="right-splitter-sub" numeric>
    -->
        <div class="cell-contents">
            <span class="edit" style="display:block" >
                <IconButton size="normal" class="tescoblue-text opacity-1"  disabled="{editDisabled}" on:click="{(e) => {editing = true; dispatch("startEdit");}}" title="{$_('click_to_edit')}" >
                    <Icon tag='svg' viewBox="0 0 25 25" class=" {editDisabled? "grey-text": "tescoblue-text"}" style="height: 2rem; opacity: .9;">
                        <path fill="currentColor" d={mdiPencilBoxOutline } />
                    </Icon>
                </IconButton>
            </span>
            <span class="">
                {#if ["ALL", (type == "carton"? "CART": "PAL")].includes(logisticsCheckType) && lwLogistics && qsLogistics != lwLogistics}
                    <span class="red lighten-3 pa-2" title={$_("lw") + ": " + lwLogistics}>
                        {purchaseLogistics}
                    </span>
                {:else if ["ALL", (type == "carton"? "CART": "PAL")].includes(logisticsCheckType) && productLogistics && qsLogistics != productLogistics}
                    <span class="yellow lighten-2 pa-2" title={$_("product") + ": " + productLogistics}>
                        {purchaseLogistics} 
                    </span>
                {:else}
                    {purchaseLogistics}
                {/if}
            </span>
        </div>
    {/if}
</Cell>

<style>
    .datatable-cell {
        border-bottom: 0px !important;
    }
    .cell-contents {
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        align-items:center;
    }
</style>
